import React from 'react';
import Window from "../components/Window";
import Form from "../components/Form";
import Input from "../components/Input";
import styled from "styled-components";
import Card from "../components/Card";
import Button from "../components/Button";
import * as api from '../lib/api';
import { useState, useEffect, useRef } from 'react';
import { NotificationManager } from "react-notifications";
import { useHistory } from "react-router-dom";
import * as validation from "../lib/validation";

function ForgotPasswordScreen() {
  const history = useHistory();
  const [username, setUsername] = useState({ value: '' });
  const [errors, setErrors] = useState({});
  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    setErrors(validate(username));

  }, [username]);


  function handleChange(e) {
    setUsername({ value: e.target.value })
  }

  async function handleResetPassword() {
    setErrors(validate(username));

    if (errors.username !== null) {
      return;
    }

    await api.resetPassword(username.value);
    history.push('/')
    NotificationManager.success(`A temporary password has been sent to your email. If it doesn't arrive soon, please contact your account's administraton`);
  }

  return (
    <Window title="Forgot Password">
      <Content>
        <ForgotPasswordContainer>
          <H1>Forgot Password?</H1>
          <ForgotPassowrdForm onSubmit={handleResetPassword}>
            <Input
              id="username"
              label="Enter your username to reset your password"
              type="text"
              autoComplete="current-username"
              invalid={errors.username}
              validationText={errors.username}
              onChange={handleChange}
            />

            <Form.Group>
              <Options>
                <Button type="submit">Submit</Button>
                <Button secondary to={'/'}>Cancel</Button>
              </Options>

            </Form.Group>
          </ForgotPassowrdForm>
        </ForgotPasswordContainer>
      </Content>
    </Window>
  )
}

const isValuePresent = validation.create((value, { isEmpty, trim }) => !isEmpty(trim(value)));

function validate(username) {
  return {
    username: isValuePresent(username.value) ? null : 'A username is required',
  };
}

const Options = styled.div`
  margin-top: 2rem;
  text-align: right;
  
  ${Button} {
    margin-left: 1rem;
  }
`;

const ForgotPasswordContainer = styled(props => <Card borderTop {...props} />)`
  flex: 1;
  max-width: 28rem;
  margin: 0 1.25rem;
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const ForgotPassowrdForm = styled(Form)`
  margin: 0;
  padding: 1.875rem;
`;

const H1 = styled.h1`
  font-weight: 300;
  margin: 0;
  margin-top: 1.875rem;
  text-align: center;
  font-size: 2rem;

  @media (max-width: 400px) {
    font-size: 1.5rem;
  }
`;


export default ForgotPasswordScreen;
